import {
  NOTIFICATION_CATEGORY_VALUES,
  NOTIFICATION_PAGE_SIZE,
  NOTIFICATION_SEARCH_MAX,
} from './categories';

/**
 * Arma el query de la bandeja.
 * URLSearchParams codifica espacios, &, =, % y acentos.
 * El % sale como %25 para que, al decodificar, el backend lo reciba literal.
 * No se envía sort ni ningún parámetro de lectura.
 */
export function buildNotificationQuery({
  page = 0,
  category = '',
  search = '',
} = {}) {
  const params = new URLSearchParams();
  const safePage = Number.isInteger(page) && page > 0 ? page : 0;
  params.set('page', String(safePage));
  params.set('size', String(NOTIFICATION_PAGE_SIZE));

  if (NOTIFICATION_CATEGORY_VALUES.includes(category)) {
    params.set('category', category);
  }

  const trimmed = typeof search === 'string'
    ? search.trim().slice(0, NOTIFICATION_SEARCH_MAX)
    : '';
  if (trimmed) {
    params.set('search', trimmed);
  }

  return params.toString();
}
